import { ApiClient } from "./apiClientCtor";
import { comboGWInterceptorReq } from "./interseptors/comboGWInterceptorReq";
import { comboInterceptorReq } from "./interseptors/comboInterceptorReq";
import { comboInterceptorResponse } from "./interseptors/comboInterResp";
import { logInterReqError } from "./interseptors/logInterReqError";
import { logInterResponseError } from "./interseptors/logInterResponseError";

export const wpApiClient = new ApiClient({
  baseURL: "",
  timeout: 30000,
});

wpApiClient.setInterceptors(comboInterceptorResponse, logInterResponseError, comboInterceptorReq, logInterReqError);
export const gwApiClient = new ApiClient({
  baseURL: "",
  timeout: 30000,
});

gwApiClient.setInterceptors(comboInterceptorResponse, logInterResponseError, comboGWInterceptorReq, logInterReqError);
